{
	"populer": "Popüler",
	"buy": "Add to Cart",
	"detail": "Details",
	"no-stock": "Sold Out",
	"optional": "Daily",
	"close": "Close",
	"speaker": "Speakers",
	"modalSpeakerTitle": "Speaker",
	"program": "Program",
	"photoAlbum": "Photo Album",
	"speakerDetail": "Speaker Details",
	"showAll": "Show All",
	"selectedSession": "Selected Sessions",
	"searchSpeakersSession": "Search for speakers in sessions...",
	"searchSpeaker": "Speaker Search...",
	"notFoundSpeaker": "No speaker was found for your query!",
	"cart": "Cart",
	"price": "Price",
	"quantity": "Quantity",
	"total": "Total: ",
	"goToCart": "Go to Cart",
	"emptyCart": "Cart is empty",
	"free": "Free",
	"modalSessionTitle": "Session",
	"programNotFound": "No program was added or the event is not published yet!",
	"photoAlbumNotFound": "Photo album was not found!",
	"faq": "FAQ",
	"areaMaps": "Area Maps",
	"areaMapsNotFound": "No area map was found!",
	"enlarge": "Enlarge",
	"my-ticket": "My Tickets",
	"brand-description-title": "Kapital Media Group",
	"brand-description": "Provided by",
	"cart_items_count_not_within_limit": "This form has a minimum {min} ticket requirement.",
	"cart_items_count_not_within_limit_with_max": "This form has a minimum {min}, maximum {max} ticket requirement.",
	"share": "Share",
	"decrease-quantity": "Decrease quantity",
	"increase-quantity": "Increase quantity",
	"remove-item": "Remove item from cart",
	"copy-link": "Copy link",
	"link-copied": "Link copied",
	"share-email": "Email",
	"sessionCount": "{count, plural, one {# session} other {# sessions}}",
	"speakerCount": "{count, plural, one {# speaker} other {# speakers}}",
	"sessionNotFound": "No sessions match your search.",
	"liveNow": "Live now",
	"biography": "About",
	"speakerSessions": "Sessions",
	"sponsor": "Sponsor",
	"sessionDate": "Date",
	"sessionTime": "Time",
	"sessionHall": "Hall",
	"sessionAbout": "About the Session",
	"eventDescription": "About the Event",
	"showMore": "Read more",
	"showLess": "Show less"
}
